import {makeStyles} from '@material-ui/core';

export const useErrorThemeButtonStyles = makeStyles(theme => ({
	root: {
		backgroundColor: theme.palette.error.main,
		color: theme.palette.getContrastText(theme.palette.error.main),
		'&:hover': {
			backgroundColor: theme.palette.error.dark,
		},
	},
}), {name: 'ErrorButton'})